module.exports = __webpack_public_path__ + "img/bilWat.71c127fa.png";